import types from "./types";
import _ from 'lodash';
import { combineReducers } from 'redux'

const loading = (state = false, action) => {
  switch (action.type) {
    case types.USER_SETTINGS_REQUEST:
      return true
    case types.USER_SETTINGS_SUCCESS:
      return false
    default:
      return state
  }
}


const settings = (state = null, action) => {
  switch (action.type) {
    case types.USER_SETTINGS_SUCCESS:
      return action.settings;
    default:
      return state
  }
}

export default combineReducers({
  settings,
  loading
})


